export enum RepresentmentRuntimeRule {
  'All Runs'
}

export namespace RepresentmentRuntimeRule {
  export function values() {
    return Object.keys(RepresentmentRuntimeRule).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}
